import { jsx } from "react/jsx-runtime";
import { Loader } from "@crehana/compass.ui";
const CurrencyLoader = ()=>/*#__PURE__*/ jsx("div", {
        className: "tw-rounded-0.4 tw-h-5.6 tw-flex tw-items-center tw-justify-center tw-bg-neutral-light-400 dark:tw-bg-neutral-dark-600",
        style: {
            width: 260
        },
        children: /*#__PURE__*/ jsx(Loader, {})
    });
const components_CurrencyLoader = CurrencyLoader;
export default components_CurrencyLoader;
